import { useMemo } from "react"

import { Navigate, Route, Routes } from "react-router-dom"
import urlJoin from "url-join"

import { ImageCollectionContextProvider } from "@l2r-front/l2r-images"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"
import { ComponentsChainer } from "@l2r-front/l2r-utils"

import { AccountSettingsDesktopLayout } from "../../modules/accountSettings/layouts/AccountSettingsLayout/AccountSettingsDesktopLayout"

import { useGetActiveModules } from "../hooks/useGetActiveModules"
import { AuthenticatedLayout } from "../layouts/AuthenticatedLayout"
import { EmptyPage } from "../pages/EmptyPage"
import { LoadingNetworkPage } from "../pages/LoadingNetworkPage"

export const AuthenticatedRoutes = () => {
    const { selectedNetwork } = useNetworksStateContext()
    const appsWithActiveModules = useGetActiveModules()

    const isMobile = useIsMobileDevice()

    const appsContexts = useMemo(() => {
        const externalContexts = Object.values(appsWithActiveModules).map(app => app.externalContexts).flat()
        return externalContexts.filter(Boolean)
    }, [appsWithActiveModules])

    const firstApp = useMemo(() => {
        return Object.values(appsWithActiveModules).sort((a, b) => a.index - b.index)[0]
    }, [appsWithActiveModules])

    const appsRoutes = useMemo(() => {
        return Object.values(appsWithActiveModules).map(app => {
            if (app.path) {
                return <Route path={urlJoin(app.path, "*")} element={<AuthenticatedLayout>{app.component}</AuthenticatedLayout>} key={app.path} />
            } else {
                return null
            }
        })
    }, [appsWithActiveModules])

    const defaultRoute = useMemo(() => {
        return firstApp?.path ? <Navigate replace to={`${firstApp.path}/`} />
            : <EmptyPage />
    }, [firstApp])

    return (
        <Routes>
            <Route path="/login/*" element={<Navigate replace to="/" />} />
            {!isMobile && <Route path="/account_settings/*" element={<AccountSettingsDesktopLayout />} />}
            {selectedNetwork && (<Route path={`/${selectedNetwork.slug}/*`} element={
                <ImageCollectionContextProvider>
                    <ComponentsChainer components={appsContexts}>
                        <Routes>
                            {appsRoutes}
                            <Route path="*" element={defaultRoute} />
                        </Routes>
                    </ComponentsChainer>
                </ImageCollectionContextProvider>
            } />)}
            <Route path="*" element={<LoadingNetworkPage />}
            />
        </Routes>
    )
}
